export class MockUploadService {
  remove = jasmine.createSpy('remove');
  upload = jasmine.createSpy('upload');
  calcPercentageOfProgression = jasmine.createSpy('calcPercentageOfProgression');
}
